<template>
  <div class="hireApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='5'></headComponent>
    <div class="h"></div>
    <div class="daohang"><a @click="$router.push('index')" href="javascript:;">首页</a><i class="el-icon-arrow-right"></i>人员招聘</div>
    <div class="main">
      <ul>
        <li v-for="(item,i) in setJob">
          <h2><span>{{item.title}}</span><font>更新时间：{{item.createtime}}</font></h2>
          <div class="con" v-html="item.content"></div>
        </li>
        
      </ul>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setJob:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getJob()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      getJob:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/job',
          dataType:'json',
          success:function(data){
            that.setJob = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .hireApp .el-message-box{
    width:30%
  }
  .hireApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .hireApp .h{
    height:96px
  }

  .hireApp .daohang{
    max-width: 1600px;
    margin: 15px auto;
    font-size:14px;
    color:#666
  }
  .hireApp .daohang a{
    color:#000
  }
  .hireApp .main{
    max-width: 1600px;
    margin: 0 auto 25px auto
  }
  .hireApp .main .txt p{
    text-indent: 2em;
    font-size: 16px;
    color: #333;
    line-height: 25px;
    padding-top: 5px 
  }
  .hireApp .main li{
    background: #fff;
    padding-bottom: 15px;
    margin-top: 15px
  }
  .hireApp .main li h2 {
    height: 50px;
  }
  .hireApp .main li h2 span{
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #15499a;
    margin-left: 18px;
  }
  .hireApp .main li h2 font{
    float: right;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #666;
    margin-right: 15px;
  }
  .hireApp .main li .con{
    width: 96%;
    margin: auto;
    display: block;
    font-size: 16px;
    color: #333;
  }
  .hireApp .main li .con *{
    font-size: 16px;
    line-height: 22px;
    padding-top: 8px
  }

  
  @media only screen and (max-width: 1199px) {
    .hireApp .header,.hireApp .h{
      height:60px;
    }
    .hireApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .hireApp .header .nav{
      text-align:right
    }
    .hireApp .header .nav li{
      margin:0 1.8vw
    }
    .hireApp .header .nav .close{
      display:none
    }
    .hireApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .hireApp .proBg{
      font-size:18px;
    }
    .hireApp .main dl dd{
      width:50%
    }
  } 
</style>